import { render, staticRenderFns } from "./AboutUsModal.vue?vue&type=template&id=51843fa2&"
import script from "./AboutUsModal.vue?vue&type=script&lang=js&"
export * from "./AboutUsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AboutUsModal.vue"
export default component.exports